
import { Vue, Component } from "vue-property-decorator";
import MapPreview from "../MapPreview.vue";
import { apiMessages } from "../../api/message-api";
import { Settings } from "@/constant/enums";
import { apiFetchNeighbourhoodsForPreview } from "../../api/preview-api";
import { Community, Neighbourhood } from "../../types/preview";
@Component({
  components: {
    MapPreview,
  },
})
export default class PlatMapPreview extends Vue {
  $overlay!: any;
  $refs!: any;
  $gmap!: any;
  $elmnt!: HTMLElement;
  private loading = false;
  private showPreview = false;
  private selectedNeighborhood = {} as Neighbourhood;
  private neighborhoods = [] as Neighbourhood[];
  private neighbourhood = "0";
  private svgUrl = "";
  private communityCode = "";
  private NECornerLatitude = "";
  private NECornerLongitude = "";
  private CenterpointLatitude = "";
  private CenterpointLongitude = "";
  private SWCornerLatitude = "";
  private SWCornerLongitude = "";
  private zoom = "" as any;
  private errors: Array<string> = [];
  private messages: any = {};
  private validationMessages: any = {};
  private fieldArr = [
    "svgUrl",
    "NECornerLatitude",
    "NECornerLongitude",
    "CenterpointLatitude",
    "CenterpointLongitude",
    "SWCornerLatitude",
    "SWCornerLongitude",
    "zoom",
  ];

  constructor() {
    super();
    this.loadMessages();
  }

  async loadMessages() {
    const { messages, validationMessage } = await apiMessages("PlatMapPreview");
    this.messages = messages;
    this.validationMessages = validationMessage;
  }

  updateSelectedNeighborhood() {
    const neighbourhood = this.neighborhoods.find(
      (neighbourhood) => neighbourhood.id === this.neighbourhood
    );
    if (neighbourhood) {
      this.selectedNeighborhood = neighbourhood;
      this.CenterpointLatitude = neighbourhood.latitude.toString();
      this.CenterpointLongitude = neighbourhood.longitude.toString();
    }
  }

  async getCommunityNeighborhoods(e) {
    this.loading = true;
    this.neighbourhood = "0";
    this.errors = [];
    try {
      const response = await apiFetchNeighbourhoodsForPreview(
        this.communityCode
      );
      const result: Community = response.result;
      if (!result.neighborhoods.length) {
        this.errors.push(this.validationMessages.noNeighborhoodFound);
      } else {
        this.neighborhoods = result.neighborhoods;
        if (this.neighborhoods.length === 1) {
          this.neighbourhood = this.neighborhoods[0].id;
        }
        this.NECornerLatitude = result.ne_corner_latitude.toString();
        this.NECornerLongitude = result.ne_corner_longitude.toString();
        this.CenterpointLatitude = result.center_latitude.toString();
        this.CenterpointLongitude = result.center_longitude.toString();
        this.SWCornerLatitude = result.sw_corner_latitude.toString();
        this.SWCornerLongitude = result.sw_corner_longitude.toString();
        this.zoom = result.zoom_level || Settings.MAP_DEFAULT_SVG_SCALE;
      }
    } catch (err) {
      this.errors.push(this.validationMessages.validCommunityCode);
      this.neighborhoods = [] as Neighbourhood[];
    }
    this.loading = false;
  }

  checkAllFieldsEmpty() {
    var isFieldEmpty = false;
    for (var item of this.fieldArr) {
      if (!this[item]) {
        isFieldEmpty = true;
      }
    }
    if (isFieldEmpty) {
      this.errors.push(this.validationMessages.emptyFields);
    }
  }

  checkValidCoordinate() {
    var isFieldEmpty = false;
    for (var item of this.fieldArr) {
      if (item != "svgUrl" && this.validateCoordinate(this[item])) {
        isFieldEmpty = true;
      }
    }
    if (isFieldEmpty) {
      this.errors.push(this.validationMessages.validCoordinates);
    }
  }

  checkLongitude() {
    if (
      this.validateLongitude(this.NECornerLongitude) ||
      this.validateLongitude(this.CenterpointLongitude) ||
      this.validateLongitude(this.SWCornerLongitude)
    ) {
      this.errors.push(this.validationMessages.validLongitude);
    }
  }

  updateZoomLevel() {
    this.errors = [];
    this.checkAllFieldsEmpty();
    this.checkZoomValidation();
    if (!this.errors.length && this.showPreview) {
      this.svgZoom();
    }
  }
  checkZoomValidation() {
    if (this.zoom && (this.zoom < 10 || this.zoom > 20)) {
      this.errors.push(this.validationMessages.validZoom);
    }
  }

  submitPreviewData() {
    this.loading = true;
    this.showPreview = false;
    this.errors = [];
    this.checkAllFieldsEmpty();
    this.checkValidCoordinate();
    this.checkLongitude();
    this.checkZoomValidation();

    if (!this.errors.length) {
      let timer = setTimeout((_) => {
        this.loading = false;
        this.showPreview = true;
        clearTimeout(timer);
      }, 1000);
    } else {
      this.loading = false;
      this.showPreview = false;
    }
  }

  validateLongitude(longitudeCoordinate: string) {
    return longitudeCoordinate && !this.validateCoordinate(longitudeCoordinate)
      ? !longitudeCoordinate.startsWith("-")
      : false;
  }

  validateCoordinate(val) {
    return val
      ? !(!isNaN(parseFloat(val)) && isFinite(parseFloat(val)))
      : false;
  }

  changeZoomLevel(zoomLevel: number) {
    this.zoom = zoomLevel;
  }

  svgZoom() {
    this.$refs.mapPreview.svgZoom(+this.zoom);
  }

  svgZoomIn() {
    this.$refs.mapPreview.svgZoomIn();
  }

  svgZoomOut() {
    this.$refs.mapPreview.svgZoomOut();
  }
}
